<script setup>
import { ref, computed, watch } from 'vue'
import { useConfigStore } from '@/stores/config'
import { useTestStore } from '@/stores/test'
import jsonImage from '@/assets/images/fieldJsonMode.jpg'

const fieldAddress  = ref(null)
const fieldMethod   = ref('GET')
const fieldJson     = ref('')
const fieldJsonMode = ref(false)
const fieldsCounter = ref(1)
const filesCounter  = ref(1)
const isFormData    = ref(false)

const configStore   = useConfigStore()
const testStore     = useTestStore()

const httpServer        = computed(() => configStore.httpServer)
const testResponse      = computed(() => testStore.testResponse)
const testRequestMsg    = computed(() => testStore.testRequestMsg)

function submitForm(form) {

    let data = {

        params: {}
    }

    const fields = form.target.elements

    if(fields.fieldAddress.value)   data.address    = fields.fieldAddress.value
    if(fields.fieldMethod.value)    data.method     = fields.fieldMethod.value
    if(fields.testHeaders.value)    data.headers    = fields.testHeaders.value
    if(fields.testToken.checked)    data.token      = true
    if(isFormData.value)            data.type       = 'formdata'

    if(fieldJsonMode.value) {

        data.params = JSON.stringify(JSON.parse(fieldJson.value))
        data.type = 'clear'

    } else {

        if(!isFormData.value) {

            for(let i = 1; i <= fieldsCounter.value; i++) {

                const keyName       = `testFieldKey_${i}`
                const valueName     = `testFieldValue_${i}`
                const keyInput      = fields[keyName]
                const valueInput    = fields[valueName]

                if(keyInput.value && valueInput.value) {

                    // Если параметр с таким ключём уже есть - помещаем значения в массив
                    if(keyInput.value in data.params) {
                        if(!Array.isArray(data.params[keyInput.value])) {
                            data.params[keyInput.value] = [data.params[keyInput.value]]
                        }
                        data.params[keyInput.value].push(valueInput.value)
                    } else {
                        data.params[keyInput.value] = valueInput.value
                    }
                }
            }

        } else {

            let formData = new FormData()

            for(let i = 1; i <= fieldsCounter.value; i++) {

                const keyName       = `testFieldKey_${i}`
                const valueName     = `testFieldValue_${i}`
                const keyInput      = fields[keyName]
                const valueInput    = fields[valueName]

                if(keyInput.value && valueInput.value) {
                    formData.append(keyInput.value, valueInput.value)
                }
            }

            for(let i = 1; i <= filesCounter.value; i++) {

                const keyName       = `testFileKey_${i}`
                const valueName     = `testFileValue_${i}`
                const keyInput      = fields[keyName]
                const valueInput    = fields[valueName]

                if(keyInput.value && valueInput.value) {
                    formData.append(keyInput.value, valueInput.files[0])
                }
            }

            data.params = formData
        }
    }

    testStore.sendTestRequest(data)
}

fieldAddress.value = httpServer.value

watch(fieldMethod, value => {
    if(value == 'GET' || value == 'DELETE') {
        fieldJsonMode.value = false
    }
})

</script>

<template>
    <div class="adt-test">

        <div class="page__body px-2 px-sm-4 my-2 my-sm-5">

            <form action="" @submit.prevent="submitForm($event)">

                <h3 class="mt-4">Адрес</h3>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <input class="form-control uta-input uta-input--block" type="text" id="fieldAddress" required v-model="fieldAddress">
                        </div>
                    </div>
                </div>

                <h3 class="mt-4">Метод</h3>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <select id="fieldMethod" class="custom-select uta-input uta-input--block" required @change="fieldMethod = $event.target.value">
                                <option value="GET" selected>GET</option>
                                <option value="POST">POST</option>
                                <option value="PUT">PUT</option>
                                <option value="DELETE">DELETE</option>
                            </select>
                        </div>
                    </div>
                </div>

                <h3 class="mt-4">Заголовки</h3>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <input type="text" id="testHeaders" class="custom-select uta-input uta-input--block" placeholder="header_name_1:header_value_1; ...">
                        </div>
                    </div>
                </div>

                <button type="button" class="uta-btn my-4" @click="isFormData = !isFormData" v-if="fieldMethod == 'POST' || fieldMethod == 'PUT'">
                    {{ isFormData ? 'Убрать файл' : 'Добавить файл' }}
                </button>

                <div class="adt-test__files" v-if="isFormData">

                    <h3 class="my-4">Файл</h3>

                    <div class="row" v-for="file of filesCounter" :key="file">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label :for="`testFileKey_${file}`">Имя поля</label>
                                <input class="form-control uta-input uta-input--block" type="text" :id="`testFileKey_${file}`">
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label :for="`testFileValue_${file}`">Выбор файла</label>
                                <input class="form-control uta-input uta-input--block" type="file" :id="`testFileValue_${file}`">
                            </div>
                        </div>
                    </div>

                </div>

                <h3 class="my-4">Параметры</h3>

                <div class="mb-4 switcher adt-car-sdm__errors-filter" v-if="(fieldMethod == 'PUT' || fieldMethod == 'POST') && !isFormData">
                    <input class="switcher__input adt-car-sdm__errors-filter-input" type="checkbox" id="testFieldsType" @change="fieldJsonMode = !fieldJsonMode">
                    <label class="switcher__label adt-car-sdm__errors-filter-label" for="testFieldsType">
                        <span class="switcher__text">Джейсон</span> 
                        <img v-if="fieldJsonMode" alt="" :src="jsonImage" class="adt-test__json" />
                    </label>
                </div>

                <template v-if="!fieldJsonMode">
                    <div class="my-4 row" v-for="field of fieldsCounter" :key="field">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label :for="`testFieldKey_${field}`">Ключ</label>
                                <input class="form-control uta-input uta-input--block" type="text" :id="`testFieldKey_${field}`">
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label :for="`testFieldValue_${field}`">Значение</label>
                                <input class="form-control uta-input uta-input--block" type="text" :id="`testFieldValue_${field}`">
                            </div>
                        </div>
                    </div>
                </template>

                <template v-else>
                    <div class="row">
                        <div class="col-12">
                            <textarea class="form-control uta-input uta-input--block" rows="15" id="testFieldValue" v-model="fieldJson"></textarea>
                        </div>
                    </div>
                </template>

                <div class="mt-4 mb-5 row">
                    <div class="col-12 col-sm-6 mb-4 mb-sm-0 d-flex justify-content-sm-end align-items-start align-items-md-center pt-sm-1 pt-md-0">
                        <label for="testToken" class="d-flex">
                            <span class="order-1 order-sm-0">Запрос с токеном</span>
                            <input type="checkbox" id="testToken" checked class="order-0 order-sm-1 me-2 me-sm-0 ms-sm-2"> 
                        </label>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="row">
                            <div class="col-12 col-md-8" v-if="!fieldJsonMode">
                                <div class="row mb-4 mb-md-0">
                                    <div class="col-6">
                                        <button href="#" class="uta-btn uta-btn--block" @click.prevent="fieldsCounter++">+</button>
                                    </div>
                                    <div class="col-6">
                                        <button href="#" :disabled="fieldsCounter < 1" class="uta-btn uta-btn--block" @click.prevent="fieldsCounter--">-</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" :class="{ 'col-md-4' : !fieldJsonMode }">
                                <button type="submit" class="uta-btn uta-btn--main uta-btn--block">Послать</button>
                            </div>
                        </div>
                    </div>
                </div>

            </form>

            <div 
                class="d-block alert" 
                :class="{
                    'uta-alert--success': testRequestMsg.success,
                    'uta-alert--danger': !testRequestMsg.success
                }"
                style="word-wrap: break-word"
                v-if="testRequestMsg"
            >
                <div class="my-4">
                    <h4>Status: {{ testRequestMsg.success ? 'OK' : 'FAIL' }}</h4>
                </div>

                <div>
                    <h5>Response:</h5>
                    <pre>{{ testResponse }}</pre>
                </div>

            </div>

        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/test';
</style>